module.exports = __webpack_public_path__ + "img/8-large.5baa83fd.png";